/**
 * Coverage Map Constants
 *
 * These live here rather than in the route that renders the map because
 * MapContent and SearchControls both need them, and importing them from the
 * route made a dependency cycle: the route imports the components, and the
 * components imported the constants back out of the route.
 */

export type CoverageMode = "baseline" | "sqi"

// Default map view settings
export const DEFAULT_INITIAL_CENTER: [number, number] = [30, 15]
export const DEFAULT_INITIAL_ZOOM = 1
export const MIN_ZOOM = 1
export const MAX_ZOOM = 13
export const SHOW_BASELINE_ZOOM = 7
export const FLY_ZOOM = 10
export const FLY_DURATION = 1500

// Default search and coverage settings
export const DEFAULT_COVERAGE_RADIUS_KM = 70
export const DEFAULT_NEAREST_STATIONS_COUNT = 3
export const DEFAULT_IS_METRIC = true
export const DEFAULT_SHOW_COVERAGE = true
export const DEFAULT_MAP_TYPE: "light" | "dark" = "light"
export const DEFAULT_COVERAGE_MODE: CoverageMode = "baseline"

// Slider ranges
export const COVERAGE_RADIUS_MIN = 30
export const COVERAGE_RADIUS_MAX = 100
export const COVERAGE_RADIUS_STEP = 1

export const NEAREST_STATIONS_MIN = 1
export const NEAREST_STATIONS_MAX = 10
export const NEAREST_STATIONS_STEP = 1

export const BASELINE_BOX_POSITION = 0.25

// Conversion factors
export const KM_TO_MILES = 0.621371
